import {
  ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../core/service/permissions.service';

/**
 * SD-1244: shows its content only to users who hold a permission in the current organisation.
 *
 *     <a *appHasPermission="'reports.financial_statements'" routerLink="...">Profit and Loss</a>
 *
 * Re-evaluates when the organisation or the permissions change.
 */
@Directive({ selector: '[appHasPermission]' })
export class HasPermissionDirective implements OnInit, OnDestroy {

  @Input('appHasPermission') appHasPermission: string;

  private subscription: Subscription;
  private rendered = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissions: PermissionsService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (!this.appHasPermission) {
      // No key given: render rather than hide, as appHasModule does.
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.rendered = true;
      return;
    }

    this.subscription = this.permissions.has$(this.appHasPermission).subscribe(allowed => {
      if (allowed && !this.rendered) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.rendered = true;
      } else if (!allowed && this.rendered) {
        this.viewContainer.clear();
        this.rendered = false;
      }
      this.changeDetector.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
